import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VerificationsState } from 'types';

export const initialState: VerificationsState = {
  loading: false,
  verificationsList: [],
  filter: {
    year: 2021,
    month: 'august',
    manufacture: 'All',
    distributor: 'All'
  }
};

const slice = createSlice({
  name: 'Verifications',
  initialState,
  reducers: {
    setVerificationsList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.verificationsList = payload || [];
    },
    // seVerificationsGroups: (state, { payload }: PayloadAction<any>) => {
    //   state.verificationsGroups = payload;
    // },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };

      state.filter = { ...state.filter, ...filter };
    }
  }
});

export const { 
  setVerificationsList,
  setFilter 
} = slice.actions;

export default slice.reducer;
